module.exports = __webpack_public_path__ + "img/投光.78dd8c13.png";